import z from 'zod';

const NUMBER = 10;
const MAX_FILE_SIZE = NUMBER * 1024 * 1024;

const PDF_TYPE = 'application/pdf';
const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg', 'image/svg+xml'];

export const documentValidationOptional = z
  .any()
  .refine((files) => {
    if (files?.length) {
      return files[0].size <= MAX_FILE_SIZE;
    }
    return true;
  }, `Max file size is ${NUMBER}MB.`)
  .refine((files) => {
    if (files?.length) {
      return files[0].type === PDF_TYPE;
    }
    return true;
  }, '.pdf files are accepted.');

export const documentValidation = documentValidationOptional.refine(
  (files) => files?.length === 1,
  'Document is required.',
);

export const imageValidation = z
  .any()
  .refine((files) => files?.length === 1, 'Image is required.')
  .refine((files) => files?.[0]?.size <= MAX_FILE_SIZE, `Max file size is 10MB.`)
  .refine(
    (files) => IMAGE_TYPES.includes(files?.[0]?.type),
    '.jpg, .jpeg, .png and .webp files are accepted.',
  );

export const fileValidation = z
  .any()
  .refine((files) => files?.length === 1, 'File is required.')
  .refine((files) => files?.[0]?.size <= MAX_FILE_SIZE, `Max file size is 10MB.`)
  .refine(
    (files) => [...IMAGE_TYPES, PDF_TYPE].includes(files?.[0]?.type),
    '.pdf, .jpg, .jpeg, .png and .webp files are accepted.',
  );
